import { CheckCircle2, AlertTriangle } from "lucide-react";
import LegalPageLayout from "@/components/landing/LegalPageLayout";

const systems = [
  { name: "Card Transaction Processing", status: "operational" },
  { name: "Crypto-to-Fiat Conversions", status: "operational" },
  { name: "Apple Pay & Google Pay", status: "operational" },
  { name: "Mobile App (iOS)", status: "operational" },
  { name: "Mobile App (Android)", status: "operational" },
  { name: "Wallet Connections", status: "operational" },
  { name: "Wallet Verification", status: "operational" },
  { name: "Rewards Processing", status: "operational" },
  { name: "ATM Network", status: "operational" },
  { name: "Customer Support Chat", status: "operational" },
];

const recentIncidents = [
  {
    date: "April 2, 2026",
    title: "Scheduled Maintenance — Rewards Engine",
    description: "Scheduled maintenance window for rewards calculation engine upgrade. No impact to card transactions. Rewards processing was delayed by approximately 2 hours.",
    severity: "maintenance",
  },
  {
    date: "March 18, 2026",
    title: "Degraded Performance — Wallet Connections",
    description: "Some users experienced delays connecting new wallets between 14:00–15:30 UTC. Root cause: upstream API rate limiting. Resolved by scaling connection pool.",
    severity: "minor",
  },
];

const StatusPage = () => {
  const now = new Date();
  const dateStr = now.toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
  const timeStr = now.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: false, timeZone: "UTC" });

  return (
  <LegalPageLayout title="System Status" lastUpdated={dateStr}>
    <div className="!mt-6 rounded-2xl border border-green-500/30 bg-green-500/5 p-6 text-center">
      <CheckCircle2 className="mx-auto h-8 w-8 text-green-500" />
      <p className="!mt-2 text-xl font-bold text-green-600">All Systems Operational</p>
      <p className="!mt-1 text-sm text-muted-foreground">Last checked: {dateStr} at {timeStr} UTC</p>
    </div>

    <section>
      <h2>Current Status</h2>
      <div className="!mt-4 divide-y divide-border/60 rounded-2xl border border-border/60 bg-card/80 overflow-hidden">
        {systems.map((system) => (
          <div key={system.name} className="flex items-center justify-between px-6 py-4">
            <span className="font-medium text-foreground">{system.name}</span>
            <div className="flex items-center gap-2">
              <div className="h-2.5 w-2.5 rounded-full bg-green-500" />
              <span className="text-sm text-green-600">Operational</span>
            </div>
          </div>
        ))}
      </div>
    </section>

    <section>
      <h2>Recent Incidents</h2>
      {recentIncidents.map((incident) => (
        <div key={incident.title} className="!mt-4 rounded-2xl border border-border/60 bg-card/80 p-6">
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <AlertTriangle className="h-4 w-4 text-amber-500" />
            {incident.date}
          </div>
          <h3 className="!mt-2">{incident.title}</h3>
          <p>{incident.description}</p>
        </div>
      ))}
    </section>

    <section>
      <h2>Uptime (Last 90 Days)</h2>
      <div className="!mt-4 grid gap-4 sm:grid-cols-3">
        {[
          { label: "Card Processing", uptime: "99.99%" },
          { label: "Mobile Apps", uptime: "99.97%" },
          { label: "Wallet Connections", uptime: "99.95%" },
        ].map((item) => (
          <div key={item.label} className="rounded-2xl border border-border/60 bg-card/80 p-6 text-center">
            <p className="text-3xl font-black text-primary">{item.uptime}</p>
            <p className="!mt-1 text-sm text-muted-foreground">{item.label}</p>
          </div>
        ))}
      </div>
    </section>


  </LegalPageLayout>
  );
};

export default StatusPage;
